import React from 'react';

export default function Help() {
  return (
    <div className='Constraints-container-help-wrap'>
      <div className='page-breadcrumb'>
        <h3>Help Center</h3>
      </div>
      <a
        href='https://support.apple.com/en-us/HT201361'
        target='_blank'
        rel='noopener noreferrer'
      >
        <div className='help-container'>
          <div className='col1'>
            <h6>GET STARTED</h6>
            <h5>How To Take Screenshots</h5>
            <p>
              Shotty lets you use the default MacOS screenshot tools to capture
              screenshots. Here’s how.
            </p>
          </div>
          <div className='col2'>
            <img
              src='https://meetshotty.com/static/34fbe5f81060738071382a6a8100374b/905ae/help-thumb-1.png'
              alt='img'
            />
          </div>
        </div>
      </a>
      <a
        href='/help/change-screenshot-folder'
        target='_blank'
        rel='noopener noreferrer'
      >
        <div className='help-container'>
          <div className='col1'>
            <h6>PRO TIP</h6>
            <h5>Customize Where Your Screenshots Are Saved</h5>
            <p>
              Keep a clean Desktop. Follow these simple steps to save your
              screenshots to a custom folder.
            </p>
          </div>
          <div className='col2'>
            <img
              src='https://meetshotty.com/static/92bb34f4f65487890d03a571a712e314/905ae/help-thumb-2.png'
              alt='img'
            />
          </div>
        </div>
      </a>
      <div className='help__Contact'>
        <h5>Still need need help?</h5>
        <p>
          Get in touch and I’ll do my best to help you. I love hearing from
          Shotty users.
        </p>
        <p>- Jacob Ruiz</p>
        <div className='help__ButtonSection'>
          <a
            href='https://twitter.com/JacobRuizDesign'
            target='_blank'
            rel='noopener noreferrer'
          >
            <button className='help__RoundButton'>
              Twitter
            </button>
          </a>
          <a href='mailto:jacobruizdesign@gmail.com'>
            <button className='help__RoundButton'>Email</button>
          </a>
        </div>
      </div>
    </div>
  );
}
